import { Stats } from "@domain";

export interface StatsState {
  stats: Stats | null;
}

export const defaultStatsState: StatsState = {
  stats: null
};
